var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("date-picker", {
    attrs: {
      editable: _vm.editable,
      disabled: _vm.disabled,
      "input-name": _vm.name,
      value: _vm.value,
      lang: _vm.lang,
      type: "time",
      format: _vm.format,
      "minute-step": parseInt(_vm.minuteStep),
      "input-class": _vm.inputClass,
    },
    on: {
      input: function ($event) {
        return _vm.onInput($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }